import {
  DataConnectionId,
  DataSourceSchemaId,
  DataSourceTableId,
  EnumValues,
  SemanticDatasetId,
  SemanticViewId,
} from "@hex/common";

export const DataBrowserRecommendedViewPanel = {
  OVERVIEW: "overview",
  RECENTLY_USED: "recently-used",
  FAVORITES: "favorites",
  ENDORSED: "endorsed",
} as const;

export type DataBrowserRecommendedViewPanel = EnumValues<
  typeof DataBrowserRecommendedViewPanel
>;

export const DataBrowserRecommendedViewDisplayObjectType = {
  SEMANTIC_DATASET: "semanticDataset",
  SEMANTIC_VIEW: "semanticView",
  TABLE: "table",
  SCHEMA: "schema",
} as const;

export type DataBrowserRecommendedViewDisplayObjectType = EnumValues<
  typeof DataBrowserRecommendedViewDisplayObjectType
>;

export type DataBrowserRecommendedViewSelection = {
  dataBrowserDataConnectionId: DataConnectionId | null;
  dataBrowserTableId: DataSourceTableId | null;
  dataBrowserSchemaId: DataSourceSchemaId | null;
  dataBrowserSemanticDatasetId: SemanticDatasetId | null;
  dataBrowserSemanticViewId: SemanticViewId | null;
  displayObjectType: DataBrowserRecommendedViewDisplayObjectType;
};
